// extracted by mini-css-extract-plugin
module.exports = {"HomePage":"VideoBlogPage-module--HomePage--4b0pe"};